import { render, staticRenderFns } from "./keyBoard.vue?vue&type=template&id=5d70c058&scoped=true&"
import script from "./keyBoard.vue?vue&type=script&lang=js&"
export * from "./keyBoard.vue?vue&type=script&lang=js&"
import style0 from "./keyBoard.vue?vue&type=style&index=0&id=5d70c058&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70c058",
  null
  
)

export default component.exports